// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1P1Db","question":"Question_question__3b8b5","description":"Question_description__1RnWo"};